import styled, { css } from 'styled-components';

export const Element = styled.div`
  ${({ theme, ...props }) => {
    return css`
      display: flex;
      flex-direction: column;
      gap: 1rem;
      height: 100%; // Required to make Spinner centered
    `;
  }};
`;

export const Form = styled.form`
  ${({ theme, ...props }) => {
    return css`
      padding-bottom: 1rem;
    `;
  }};
`;
